module.exports = __webpack_public_path__ + "img/sub13.b306bf19.jpg";